import { render, staticRenderFns } from "./newsCateAdd.vue?vue&type=template&id=f1316218&scoped=true"
import script from "./newsCateAdd.vue?vue&type=script&lang=js"
export * from "./newsCateAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1316218",
  null
  
)

export default component.exports